const PROVIDER_LABELS = {openai: 'OpenAI', google_gemini: 'Google Gemini'};
let catalogRequest;

function groupJudgmentModels(models) {
    return models.reduce((groups, model) => {
        const provider = model.provider || 'other';
        let group = groups.find(item => item.provider === provider);
        if (!group) {
            group = {provider, label: PROVIDER_LABELS[provider] || provider, models: []};
            groups.push(group);
        }
        group.models.push(model);
        return groups;
    }, []);
}

function formatModelPrice(value) {
    if (value == null || value === '') return '-';
    return Number.isFinite(Number(value)) ? `$${Number(value).toFixed(2)}` : '-';
}

function modelLabel(model) {
    return `${model.label} · 입력 ${formatModelPrice(model.pricing?.input)} / 출력 ${formatModelPrice(model.pricing?.output)} (USD / 1M tokens)`;
}

export default {
    data() {
        return {
            judgmentModel: null,
            judgmentModelGroups: [],
            judgmentModelsLoading: true,
            judgmentModelsError: false,
            defaultJudgmentModelLabel: '기본값 (지정 안 함)',
            defaultJudgmentModelDetail: '',
        };
    },
    computed: {
        selectedJudgmentModelNote() {
            for (const group of this.judgmentModelGroups) {
                const model = group.models.find(item => item.id === this.judgmentModel);
                if (model) return model.note || null;
            }
            return null;
        },
    },
    created() {
        this.loadJudgmentModels();
    },
    methods: {
        judgmentModelLabel(model) {
            return modelLabel(model);
        },
        async loadJudgmentModels() {
            this.judgmentModelsLoading = true;
            this.judgmentModelsError = false;
            try {
                if (!catalogRequest) {
                    catalogRequest = this.$axios.get('/assessments/ai-audit/judgment-models')
                        .then(({data}) => data)
                        .catch(error => {
                            catalogRequest = null;
                            throw error;
                        });
                }
                const data = await catalogRequest;
                const models = Array.isArray(data?.models) ? data.models : [];
                const defaultModel = models.find(model => model.id === data?.default_model);
                this.judgmentModelGroups = groupJudgmentModels(models);
                this.defaultJudgmentModelLabel = defaultModel
                    ? `기본값 (지정 안 함 · ${defaultModel.label})`
                    : '기본값 (지정 안 함)';
                this.defaultJudgmentModelDetail = defaultModel ? modelLabel(defaultModel) : '';
            } catch (error) {
                this.judgmentModelGroups = [];
                this.judgmentModelsError = true;
                this.defaultJudgmentModelLabel = '기본값 (지정 안 함)';
                this.defaultJudgmentModelDetail = '';
            } finally {
                this.judgmentModelsLoading = false;
            }
        },
    },
};
